<script>
	import SVG from "./SVG.svelte";

	const svgConfig = {
		x: 0,
		y: 50,
		width: 600,
		height: 470,
		card: { height: 1100 * 0.2, width: 800 * 0.2, x: "60", y: "70" },
	};
</script>

<SVG {svgConfig} />

<style>
</style>
